export default "__VITE_ASSET__T7wE$Lbg__"